import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
  try {
    const resp = await new Client(options)[options.method]();
    return resp;
  } catch (error) {
    throw error;
  }
};

export async function getLogos() {
  return executeRequest({ method: "get", path: "/annual-reset/logo-url" });
}

export async function getUploadUrls(params?: any) {
  return executeRequest({ method: "post", path: "/misc/logoUploadUrl" });
}
